import { AiOutlineHome } from "react-icons/ai";
import { BsBuildings, BsCollection, BsJournal, BsJournalAlbum, BsJournalRichtext, BsList, BsPeople, BsFolder2Open } from "react-icons/bs";
import { PiBookOpenUser } from "react-icons/pi";
import { GoProjectRoadmap, GoOrganization } from "react-icons/go";
import { TbChartArea } from "react-icons/tb";
import { IoIosTimer } from "react-icons/io";

export const SidebarData = [
  {
    title: "Home",
    path: "/home",
    icon: <AiOutlineHome />,
    cName: "nav-text text-left",
  },
  {
    title: "User Masters",
    path: "#",
    icon: <BsList />,
    cName: "sub-nav-text",
    subNav: [
      {
        title: "User",
        path: "/usersmaster/userMaster",
        icon: <BsPeople />,
        cName: "sub-nav-text",
      },
      {
        title: "Organization",
        path: "/usersmaster/organizationMaster",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "User Role",
        path: "/usersmaster/userRole",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "User Group",
        path: "/usersmaster/userGroup",
        icon: <BsCollection />,
        cName: "sub-nav-text",
      },
    ],
  },
  {
    title: "Master",
    path: "#",
    icon: <BsList />,
    cName: "sub-nav-text",
    subNav: [
      {
        title: "Department Master",
        path: "/master/departmentMaster",
        icon: <BsBuildings />,
        cName: "sub-nav-text",
      },
      {
        title: "Project Master",
        path: "/master/projectMaster",
        icon: <BsJournal />,
        cName: "sub-nav-text",
      },
      {
        title: "Project Type Master",
        path: "/master/projectTypeMaster",
        icon: <BsJournalAlbum />,
        cName: "sub-nav-text",
      },
      {
        title: "Phase Master",
        path: "/master/phaseMaster",
        icon: <BsJournalRichtext />,
        cName: "sub-nav-text",
      },
      {
        title: "Project User Master",
        path: "/master/projectUserMaster",
        icon: <PiBookOpenUser />,
        cName: "sub-nav-text",
      },
      {
        title: "Project Phase Activity",
        path: "/master/projectPhaseActivity",
        icon: <GoProjectRoadmap />,
        cName: "sub-nav-text",
      },
      {
        title: "Key Result Area Master",
        path: "/master/kraMaster",
        icon: <TbChartArea />,
        cName: "sub-nav-text",
      },
      {
        title: "Time Sheet",
        path: "/master/timeSheet",
        icon: <IoIosTimer />,
        cName: "sub-nav-text",
      },
    ],
  },
  {
    title: "Support Management",
    path: "#",
    icon: <BsFolder2Open />,
    cName: "sub-nav-text",
    subNav: [
      {
        title: "Support Form",
        path: `${process.env.REACT_APP_GMIS_WEB_URL || 'http://localhost:3006'}/support-system/support-form?action=add`,
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        isExternal: true,
      },
    ],
  },
];